import { ConvexQueryClient } from "@convex-dev/react-query";
import { QueryClient } from "@tanstack/react-query";
import { ConvexReactClient } from "convex/react";
import { env } from "@/env";

const FIVE_MINUTES = 1000 * 60 * 5;
const THIRTY_MINUTES = 1000 * 60 * 30;

export const convexClient = new ConvexReactClient(env.VITE_CONVEX_URL);
export const convexQueryClient = new ConvexQueryClient(convexClient);

export const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			queryKeyHashFn: convexQueryClient.hashFn(),
			queryFn: convexQueryClient.queryFn(),
			staleTime: FIVE_MINUTES,
			gcTime: THIRTY_MINUTES,
		},
	},
});

convexQueryClient.connect(queryClient);
